<button mat-icon-button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h1 mat-dialog-title class="dialog-title-container"></h1>
<div mat-dialog-content class="dialog-content approval">
  <form
    class="form"
    (ngSubmit)="send($event)"
    #heroForm="ngForm"
    enctype="multipart/form-data"
  >
    <div class="form">
      <mat-form-field>
        <mat-label>To*</mat-label>

        <input matInput value="{{to}}" name="to" readonly />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Cc</mat-label>

        <input matInput value="{{cc}}" name="cc" readonly />
      </mat-form-field>

      <mat-form-field appearance="outline" class="feedback">
        <mat-label></mat-label>
        <textarea
          rows="7"
          matInput
          [(ngModel)]="formDetails.body"
          name="body"
        ></textarea>
      </mat-form-field>
    </div>
    <div class="footer">
      <button class="cancel" (click)="close()" type="button">CANCEL</button>
      <app-primary-button
        [disabled]=" !formDetails.body "
        class="btn"
        label="SEND"
        type="submit"
      ></app-primary-button>
    </div>
  </form>
</div>
